import Sidebardigital from '../Sidebar/Sidebardigital';
import Sidebarblank from '../Sidebar/Sidebarblank';
import '../Sidebar/Sidebarprojects';
 import Operation_image from './farmoperation.png';
 import Operation_text from './farmoperation1.png';
 import Irrigation_automation from './irrigation automation.png';
 import {Link } from 'react-router-dom';
 import React from 'react';
 
export default function Farmoperation()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebardigital />
        </div>
        <div className="col-8 custom-width">
            <br/><br/>
            <h4> <strong>Automation in Agriculture:</strong></h4><br/>
            <p><strong>Get the data directly from the farms. We collect data digitally from the farm for the below two categories</strong></p>
            <ul>
            <li>1. Irrigation Automation </li>
            <li>2. Farm Operations</li>
            </ul>
            <br/>
            
          <h5><strong>Irrigation Automation</strong></h5><br/>

          <div>
                <img className="image_style" src={Irrigation_automation} style={{width: '150%', height: 'auto', margin: '0', maxWidth: '100%' }} alt=" "/>
            </div> 
            <p>For more information</p><Link to='/irrigation'> Irrigation Automation</Link><br/><br/>
            <br/>
        <h4><strong>Manage Farming operation</strong></h4><br/>
        <h5>Contract farming operations with two way communication between Agronomist, farmer and farming company</h5><br/>

        
        <div>
                <img className="image_style" src={Operation_image} style={{width: '100%', height: 'auto'}} alt=" "/>
            </div>
            <br/><br/>
            <div>
                <img className="image_style" src={Operation_text} style={{width: '100%', height: 'auto'}} alt=" "/>
            </div> 
        </div>
 
        <div className="col-2 custom-display">
          <Sidebarblank />
        </div>
        </div>
     </>
    )   
   };